<!--
    file type .....: HTML file: dw-spinner.component.html
    Created By ....: ianday
    Date ..........: 11/27/23 
-->
<div *ngIf="_visible">
    <div class="spinner-container">
        <mat-spinner class="mat-spinner-color"
                     style="scale: 40%"></mat-spinner>
    </div>

    <div  class="message-span-container">
        <span style="color: var(--appColor)">{{waitMessage}}</span>
    </div>
</div>
